export const dnldSenderLists = (builder) => ({
    dnldSenderLists: builder.mutation({
      query: ({ registered_by, category, country, search, status, loggedin_user_id, user_type_id, user_id }) => {
        const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
        return {
          url: '/download_sender_ids_list',
          method: 'GET',
          params: { registered_by, category, country, search, status, loggedin_user_id, user_type_id, user_id },
          headers: {
            'Content-Type': 'text/csv',
            'Authorization': token
          },
          responseHandler: (response) => response.blob(),
        };
      },
    }),
  });
  